import Base from '../base'

function getCafeWaiters(cafe_id) {
    return Base.get(`waiters/list/${cafe_id}`);
}

function createWaiter(cafe_id) {
    return Base.post(`waiters/create`, {
        cafe_id
    });
}

function getWaiterById(waiter_id) {
    return Base.get(`waiters/profile/${waiter_id}`);
}

function updateWaiter(id, data) {
    return Base.post(`waiters/update/${id}`, data);
}

function removeWaiter(id) {
    return Base.post(`waiters/remove/${id}`);
}

function getDeeplink(id) {
    return Base.get(`waiters/deeplink/${id}`);
}

function getOrdersHistory(id, start, end) {
    return Base.get(`waiters/orders_history/${id}`, {
        start,
        end
    });
}

function withdrawTips(waiter_id, amount) {
    return Base.post(`waiters/withdraw_tips/${waiter_id}`, {
        amount
    });
}

function getTipsHistory(waiter_id) {
    return Base.get(`waiters/tips_history/${waiter_id}`);
}

export default {
    getCafeWaiters,
    createWaiter,
    getWaiterById,
    updateWaiter,
    removeWaiter,
    getDeeplink,
    getOrdersHistory,
    withdrawTips,
    getTipsHistory
}